// @flow
import type {
  CalculationStatus,
  InspectionGibddCalculation,
  InspectionGibddCalculationMonth
} from './../types';
import CommonApi from '../commonApi';
import { convertFromKopToRub, convertFromRubToKop } from '../helpers';
import { downloadRequestWithToken, fetchRequest } from './index';

export const convertDataToServer = (
  inspectionGibddCalculation: InspectionGibddCalculation
): InspectionGibddCalculation => ({
  ...inspectionGibddCalculation,
  sum: convertFromRubToKop(inspectionGibddCalculation.sum),
  months: inspectionGibddCalculation.months.map(convertDataToServerMonth)
});

export const convertDataFromServer = (
  inspectionGibddCalculation: InspectionGibddCalculation
): InspectionGibddCalculation => ({
  ...inspectionGibddCalculation,
  sum: convertFromKopToRub(inspectionGibddCalculation.sum),
  months: inspectionGibddCalculation.months.map(convertDataFromServerMonth)
});

export const convertDataToServerMonth = (
  inspectionGibddCalculationMonth: InspectionGibddCalculationMonth
): InspectionGibddCalculationMonth => ({
  ...inspectionGibddCalculationMonth,
  cost: convertFromRubToKop(inspectionGibddCalculationMonth.cost),
  price: convertFromRubToKop(inspectionGibddCalculationMonth.price)
});

export const convertDataFromServerMonth = (
  inspectionGibddCalculationMonth: InspectionGibddCalculationMonth
): InspectionGibddCalculationMonth => ({
  ...inspectionGibddCalculationMonth,
  cost: convertFromKopToRub(inspectionGibddCalculationMonth.cost),
  price: convertFromKopToRub(inspectionGibddCalculationMonth.price)
});

const basedUrl = 'inspectionGibddCalculation';
const inspectionGibddCalculation = new CommonApi<InspectionGibddCalculation>(
  basedUrl,
  'расчет потребности в ТО ГИБДД',
  convertDataToServer,
  convertDataFromServer
);

const calculate = async (vehiclePlanId: number) => {
  const updated = await fetchRequest.put(
    `/${basedUrl}/calculate/${vehiclePlanId}`
  );
  if (updated) return updated;
  throw new Error(`Не удалось произвести расчет`);
};

const changeStatus = async (
  vehiclePlanId: number,
  status: CalculationStatus
) => {
  const updated = await fetchRequest.put(`/${basedUrl}/changeStatus`, {
    vehiclePlanId,
    status
  });
  if (updated) return updated;
  throw new Error(`Не удалось сменить статус`);
};

const print = async (vehiclePlanId: number, filter: any) => {
  const printed = await downloadRequestWithToken(`/${basedUrl}/print`, {
    ...filter,
    vehiclePlanId
  });
  if (printed) return printed;
  throw new Error('Не удалось загрузить файл');
};

const updateMonth = async monthData => {
  const updated = await fetchRequest.put(
    `/InspectionGibddCalculation/correct`,
    convertDataToServerMonth(monthData)
  );
  if (!updated) {
    throw new Error(`Не удалось сменить статус расчет`);
  }
};

export default {
  ...inspectionGibddCalculation,
  calculate,
  changeStatus,
  print,
  updateMonth
};
